import React, { useEffect, useState } from "react";
import "./ProfilePage.css";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import dummyProfile from "../../images/dummyProfile.jpg";
import CountrySelect from "../countrySelect";
import { useAlert } from "react-alert";
import api from "../../api";
import userAction from "../../redux/users/action";
import { Edit } from "lucide-react";

const ProfilePage = () => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();
  const dispatch = useDispatch();
  const { setUser } = userAction;

  const [userData, setUserData] = useState({});
  const [inputData, setInputData] = useState({});
  const [openEdit, setOpenEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const [imgLoader, setImgLoader] = useState(false);

  useEffect(() => {
    setUserData(userStore?.users?.user || {});
    setInputData(userStore?.users?.user || {});
  }, [userStore?.users]);

  const onTextChange = (e) => {
    if (e.label) {
      setInputData({ ...inputData, country: e.label });
    } else {
      setInputData({ ...inputData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async () => {
    try {
      if (!inputData?.name) {
        alert.show("Please insert name");
        return;
      }
      if (!inputData?.dob) {
        alert.show("Please insert DOB");
        return;
      }

      if (!inputData?.country) {
        alert.show("Please select country");
        return;
      }
      setLoader(true);
      const formData = {
        ...inputData,
        // dob: `${data?.year}-${data?.month}-${data?.day}`,
      };

      const signalResponse = await api.userProfileEdit(formData);
      // console.log(signalResponse);

      if (signalResponse?.success) {
        let updatedData = userStore?.users;
        updatedData.user.name = inputData.name;
        updatedData.user.dob = inputData.dob;
        updatedData.user.country = inputData.country;
        dispatch(setUser(updatedData));
        alert.show("Profile Updated Successfully");
        setOpenEdit(false);
        setLoader(false);
      } else {
        setLoader(false);
        alert.show("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert.show("Something went wrong");
    }
  };

  const handleImgUpload = async (e) => {
    try {
      console.log(e.target.files);
      setImgLoader(true);

      const formData = new FormData();
      formData.append("image", e.target.files[0], e.target.files[0].name);
      const response = await api.updateUserProfileImg(formData);
      if (response?.success) {
        let updatedData = userStore?.users;
        updatedData.user.profileImg = response?.profileImg;
        dispatch(setUser(updatedData));
      } else {
        alert.show("Image upload failed");
      }
      setImgLoader(false);
    } catch (e) {
      alert.show("Image upload failed");
      setImgLoader(false);
      console.log(e);
    }
  };

  return (
    <div className="profile-wrapper py-5">
      <div className="container">
        {/* Title */}
        <div className="text-center mb-5">
          <h1 className="profile-title">Profile Details</h1>
          <p className="profile-subtitle">
            Manage your personal details and keep your account information up to
            date.
          </p>
        </div>

        {/* Top Section */}
        <div className="row g-4 align-items-start">
          {/* Left Column */}
          <div className="col-lg-4 order-2 order-lg-1">
            <div className="info-card">
              <div className="card-header-gradient">
                Contact & Account Details
              </div>

              <div className="p-4">
                <p>
                  <strong>Email:</strong> {userData?.email}
                  {/* <span className="verified-badge ms-2">✓</span> */}
                  <RiVerifiedBadgeFill
                    className="color-verified"
                    fontSize={22}
                  />
                </p>

                <p>
                  <strong>Phone Number:</strong> {userData?.phone || "-"}
                </p>

                <p>
                  <strong>Account Created:</strong> {userData?.createdAt}
                </p>
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-lg-8 order-1 order-lg-2">
            <div className="profile-card p-3">
              <div className="d-flex justify-content-between align-items-start r1">
                <div className="pr">
                  <div className="avatar-wrapper">
                    {userData?.profileImg ? (
                      <img
                        src={`${process.env.REACT_APP_S3URL}/${userData?.profileImg}`}
                        alt="avatar"
                        className="profile-avatar"
                      />
                    ) : (
                      <img
                        src={dummyProfile}
                        alt="avatar"
                        className="profile-avatar"
                      />
                    )}
                  </div>
                  <div className="editImage">
                    <label>
                      <Edit />
                      <input
                        type="file"
                        name=""
                        id=""
                        onChange={(e) => handleImgUpload(e)}
                        accept="image/*"
                      />
                    </label>
                  </div>
                </div>
                {openEdit ? (
                  <button
                    className="themeBtn"
                    onClick={() => setOpenEdit(false)}
                  >
                    Cancel
                  </button>
                ) : (
                  <button
                    className="themeBtn"
                    onClick={() => setOpenEdit(true)}
                  >
                    Edit Profile
                  </button>
                )}
              </div>

              <hr />

              <div className="profile-detail">
                <div className="title">Full Name:</div>
                {openEdit ? (
                  <div>
                    <input
                      type="text"
                      className={"form-control"}
                      value={inputData?.name}
                      onChange={onTextChange}
                      name="name"
                    />
                  </div>
                ) : (
                  <>{userData?.name}</>
                )}
              </div>

              <div className="profile-detail">
                <div className="title">Date of Birth:</div>

                {openEdit ? (
                  <div>
                    <input
                      className={"form-control"}
                      type="date"
                      value={inputData?.dob}
                      onChange={onTextChange}
                      name="dob"
                    />
                  </div>
                ) : (
                  <>{userData?.dob}</>
                )}
              </div>

              {/* <div className="profile-detail">
                <strong>Username:</strong> {userData?.name}
              </div> */}

              <div className="profile-detail">
                <div className="title">Email Address:</div>

                {userData?.email}
              </div>

              <div className="profile-detail">
                <div className="title">Country:</div>

                {openEdit ? (
                  <div>
                    <CountrySelect onTextChange={onTextChange} />
                  </div>
                ) : (
                  <>{userData?.country}</>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Save Button */}
        {openEdit && (
          <div className="text-center mt-5">
            <button
              className="themeBtn mx-auto"
              onClick={handleSubmit}
              disabled={loader}
            >
              {loader && (
                <i
                  className="fa fa-spinner fa-pulse mx-2 mb-1"
                  style={{ position: "relative", top: "-0px" }}
                ></i>
              )}
              Save Changes
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilePage;
